import React, { useState } from 'react'
import { toast } from "react-toastify";
import {
    CLOSEICON
} from "../../constants/imagepath";
import { subscribeForJobAlerts } from '../../api_services/api_calls/jobsApi';

const SubscribeNowModal = ({ isOpen, onClose, userData, hideSubscribeButton }) => {
    const [loading, setLoading] = useState(false);
    const [showunsubscribeButton, setShowunsubscribeButton] = useState(userData.profile_data?.job_alerts ? true : false);
    console.log("showunsubscribeButtons",showunsubscribeButton,userData.profile_data?.job_alerts)
    const subscribe = (jobAlerts) => {
        setLoading(true);
        subscribeForJobAlerts({ job_alerts: jobAlerts ? 1 : 0 }).then(function (resp) {
            //setHasMoreItems(false);
            setLoading(false);
            if (resp.data.status === true) {
                toast.success(resp.data.message);
                setShowunsubscribeButton(!showunsubscribeButton);
                hideSubscribeButton()
            } else {
                toast.error(resp.data.message);
            }
            // close the modal
            closePackageModal()
        }).catch(function (error) {
            toast.error("Something went wrong");
            // close the modal
            closePackageModal()
        });
    }
    const closePackageModal = () => {
        onClose(!isOpen);
    };
    return (
        <>

            {isOpen ?
                <div id="productPopup" className="overlay_2 text-left">

                    <div className="popup1">
                        <div className="row">
                            <div className="popup-header custom-close-btn px-5 py-3">
                                <a className="close" href="javascript:void(0)">
                                    <img
                                        alt="closeIcon"
                                        src={CLOSEICON}
                                        onClick={closePackageModal}
                                    />
                                </a>
                            </div>
                            <div className="row p-4">
                                {
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className='col-12'>
                                                <h6 className='ml-2'>
                                                    Are you sure you want to {showunsubscribeButton ? "unsubscribe" : "subscribe"} the job alerts?
                                                </h6>
                                            </div>
                                        </div>
                                        {
                                            <>
                                                <div className="col-sm-8">
                                                    {
                                                        showunsubscribeButton ? <button disabled={loading ? true : false} onClick={() => subscribe(false)}>{loading ? 'Unsubscribing...' : 'Unsubscribe'}</button> :
                                                            <button disabled={loading ? true : false} onClick={() => subscribe(true)}>{loading ? 'Subscribing...' : 'Subscribe'}</button>

                                                    }

                                                    <button className="ml-2" onClick={closePackageModal}>No</button>
                                                </div>
                                            </>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                : ""}

        </>
    )
}

export default SubscribeNowModal